import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';
export const getLeavesHistoryList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.POST,
    url: URL.LEAVE_LIST,
    data,
  });
};

export const getPendingLeavesList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.POST,
    url: URL.PENDING_LEAVE_LIST,
    data,
  });
};

export const approveAttendance = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.POST,
    url: URL.ATTENDANCE_APPROVE,
    data,
  });
};

export const getAttendanceList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.POST,
    url: URL.ATTENDANCE_LIST,
    data,
  });
};

export const getAttendanceDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.GET,
    url: URL.ATTENDANCE_DETAILS,
    params,
  });
};

export const getLeaveDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.GET,
    url: URL.LEAVE_DETAILS,
    params,
  });
};

export const approveRejectLeave = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.PUT,
    url: URL.APPROVE_REJECT_LEAVE,
    data,
  });
};
